const checkoutBn = {
	header: {
		title: '🛒 চেকআউট',
		subtitle: 'আপনার অর্ডার সম্পন্ন করতে নিচের ধাপগুলো অনুসরণ করুন'
	},
	steps: ['অর্ডার বিবরণ', 'শিপিং তথ্য', 'পেমেন্ট', 'নিশ্চিতকরণ'],
	order: {
		details: 'অর্ডার বিবরণ',
		verify: 'অনুগ্রহ করে আপনার অর্ডারকৃত পণ্যগুলো যাচাই করুন',
		subtotal: 'সাবটোটাল',
		delivery: 'ডেলিভারি চার্জ',
		free: 'ফ্রি 🎉',
		total: 'মোট',
		goToShipping: 'শিপিং তথ্যে যান'
	},
	shipping: {
		title: 'শিপিং তথ্য',
		desc: 'পণ্য ডেলিভারির জন্য আপনার সঠিক তথ্য প্রদান করুন',
		fullName: 'পূর্ণ নাম *',
		email: 'ইমেইল *',
		phone: 'ফোন নম্বর *',
		district: 'জেলা *',
		noDistrict: 'কোন জেলা পাওয়া যায়নি',
		searchDistrict: 'জেলা খুঁজুন...',
		city: 'শহর/উপজেলা *',
		postal: 'পোস্টাল কোড',
		address: 'সম্পূর্ণ ঠিকানা *',
		addressPh: 'বাড়ি/ফ্ল্যাট নম্বর, রাস্তার নাম, এলাকা',
		instruction: 'ডেলিভারি নির্দেশনা (ঐচ্ছিক)',
		instructionPh: 'বিশেষ নির্দেশনা যেমন: গেটের পাশে রাখুন, ফোন করে জানান ইত্যাদি',
		prev: 'পূর্ববর্তী',
		goToPayment: 'পেমেন্টে যান',
		notice: '📍 গ্রামিণবাজার ও গ্রামিণ ডেলিভারির সার্ভিস এরিয়ার ভেতরে কয়েক ঘন্টার ভেতরে ডেলিভারি আর সার্ভিস এরিয়ার বাহিরে (দেশব্যাপি) 2-3 দিনের ভেতরে ডেলিভারি',
		errors: {
			fullName: 'পূর্ণ নাম প্রয়োজন',
			email: 'বৈধ ইমেইল প্রয়োজন',
			phone: 'বৈধ বাংলাদেশী ফোন নম্বর প্রয়োজন',
			address: 'ঠিকানা প্রয়োজন',
			city: 'শহর প্রয়োজন',
			district: 'জেলা নির্বাচন করুন'
		}
	},
	payment: {
		title: 'পেমেন্ট পদ্ধতি',
		desc: 'আপনার সুবিধামতো পেমেন্ট পদ্ধতি নির্বাচন করুন',
		info: 'পেমেন্ট তথ্য',
		mobile: 'মোবাইল নম্বর *',
		cardNumber: 'কার্ড নম্বর *',
		cardHolder: 'কার্ডধারীর নাম *',
		expiry: 'মেয়াদ শেষ *',
		cvv: 'CVV *',
		recommended: 'সুপারিশকৃত',
		cashSelectedTitle: '🎉 ক্যাশ অন ডেলিভারি নির্বাচিত!',
		cashSelectedDesc: 'পণ্য পৌঁছানোর সময় টাকা পরিশোধ করুন। কোনো অগ্রিম পেমেন্টের প্রয়োজন নেই।',
		orderSummary: '💰 অর্ডার সারাংশ',
		paymentFee: 'পেমেন্ট ফি',
		labels: {
			mobilePh: '০১XXXXXXXXX',
			cardNumberPh: '১২৩৪ ৫৬৭৮ ৯০১২ ৩৪৫৬',
			expiryPh: 'MM/YY',
			cvvPh: '১২৩'
		},
		prev: 'পূর্ববর্তী',
		confirm: 'অর্ডার নিশ্চিত করুন',
		processing: 'অর্ডার প্রক্রিয়াকরণ...'
	},
	sidebar: {
		orderSummary: 'অর্ডার সারাংশ',
		moreItems: (n) => `আরও ${n}টি পণ্য...`,
		notices: {
			securePayment: 'নিরাপদ পেমেন্ট',
			fastDelivery: 'দ্রুত ডেলিভারি',
			warranty: 'গ্যারান্টি সহ'
		}
	},
	success: {
		title: 'অর্ডার সফল!',
		orderNo: (id) => `অর্ডার নম্বর: #${id}`,
		desc: 'আপনার অর্ডারটি সফলভাবে গ্রহণ করা হয়েছে। আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব।',
		deliveryInfo: 'ডেলিভারি তথ্য',
		track: 'অর্ডার ট্র্যাক করুন',
		home: 'হোমে ফিরুন',
		fields: {
			name: 'নাম',
			phone: 'ফোন',
			address: 'ঠিকানা',
			payment: 'পেমেন্ট',
			total: 'মোট'
		}
	},
	guards: {
		cartEmpty: 'আপনার কার্ট খালি। অনুগ্রহ করে প্রথমে পণ্য যোগ করুন।',
		startShopping: 'কেনাকাটা শুরু করুন'
	},
	paymentMethods: {
		cash: { name: 'ক্যাশ অন ডেলিভারি', desc: 'পণ্য পৌঁছানোর সময় টাকা পরিশোধ করুন', fee: 0 },
		bkash: { name: 'বিকাশ', desc: 'বিকাশের মাধ্যমে পেমেন্ট করুন', fee: 0 },
		nagad: { name: 'নগদ', desc: 'নগদের মাধ্যমে পেমেন্ট করুন', fee: 0 },
		rocket: { name: 'রকেট', desc: 'রকেটের মাধ্যমে পেমেন্ট করুন', fee: 0 },
		card: { name: 'ক্রেডিট/ডেবিট কার্ড', desc: 'ভিসা, মাস্টারকার্ড বা অন্যান্য কার্ড', fee: 25 },
		bank: { name: 'ব্যাংক ট্রান্সফার', desc: 'সরাসরি ব্যাংক অ্যাকাউন্টে ট্রান্সফার', fee: 15 }
	}
};

export default checkoutBn;


